export const LOCALHOST = "localhost";
export const DEVELOPMENT = "development";
export const QA = "qa";
export const STAGING = "staging";
export const DEMO = "demo";
export const PRODUCTION = "production";

export const ENVIRONMENTS = {
  LOCALHOST,
  DEVELOPMENT,
  QA,
  STAGING,
  DEMO,
  PRODUCTION,
};

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: "page_view",
  SIGN_UP: "sign_up",
  LOGIN: "login",
  SELECT_CONTENT: "select_content",
  FILE_DOWNLOAD: "file_download",
  UI_INTERACTION: "ui_interaction",
  PAGE_ENGAGEMENT: "page_engagement",
};

// GA4 counts engagement once a page has been in the foreground for 1 second.
export const ENGAGEMENT_MIN_MS = 1000;

export const CUSTOM_DIMENSIONS = {
  DASHBOARD: "dashboard",
  USER_ID: "user_id",
  USER_NAME: "user_name",
  USER_ROLE: "user_role",
  SUBSCRIPTION_PLAN: "subscription_plan",
  ENVIRONMENT: "environment",
  FINANCIAL_INSTITUTION_TYPE: "financial_institution_type",
  FINANCIAL_INSTITUTION: "financial_institution",
  FINANCIAL_INSTITUTION_ID: "financial_institution_id",
  IDRSSD: "idrssd",
};

export const ANALYTICS_STORAGE_KEYS = {
  SESSION_ID: "analytics_session_id",
  SESSION_START: "analytics_session_start",
  LOGIN_TIME: "analytics_login_time",
};

export const REGION_FALLBACKS = {
  US: "US",
  CANADA: "Canada",
  INDIA: "India",
  EUROPE: "Europe",
};

export const DEBOUNCE_MS = {
  SCROLL: 800,
  RESIZE: 800,
  MOUSEMOVE: 800,
};

export const DEDUPE_WINDOW_MS = 1200;

const normalizeEnvironmentName = (value = "") => value.toLowerCase().trim();

const getLocationHostname = (location) => {
  if (!location) return "";
  return location.hostname || "";
};

export const isLocalDevelopment = (location = globalThis?.location) => {
  const host = getLocationHostname(location);
  const hostIsLocal =
    host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";

  return process.env.NODE_ENV === "development" && hostIsLocal;
};

export const resolveEnvironment = () => {
  const fromEnv = normalizeEnvironmentName(process.env.REACT_APP_CURRENT_ENV);
  const fromNode = normalizeEnvironmentName(process.env.NODE_ENV);

  if (fromEnv.includes("localhost")) {
    return ENVIRONMENTS.LOCALHOST;
  }
  if (fromEnv.includes("development")) {
    return ENVIRONMENTS.DEVELOPMENT;
  }
  if (fromEnv.includes("qa")) return ENVIRONMENTS.QA;
  if (fromEnv.includes("staging")) {
    return ENVIRONMENTS.STAGING;
  }
  if (fromEnv.includes("demo")) return ENVIRONMENTS.DEMO;
  if (fromEnv.includes("prod")) return ENVIRONMENTS.PRODUCTION;

  if (fromNode === "production") return ENVIRONMENTS.PRODUCTION;
  if (fromNode === "development") return ENVIRONMENTS.DEVELOPMENT;
  if (fromNode === "test") return ENVIRONMENTS.QA;

  return ENVIRONMENTS.DEVELOPMENT;
};

export const resolveMeasurementId = () =>
  process.env.REACT_APP_GA_MEASUREMENT_ID || "";

export const isApiTrackingEnabled = () =>
  process.env.REACT_APP_API_TRACKING_ENABLED?.trim().toLowerCase() !== "false";

export const isErrorTrackingEnabled = () =>
  process.env.REACT_APP_ERROR_TRACKING_ENABLED?.trim().toLowerCase() !==
  "false";

export default ENVIRONMENTS;
